// src/main.js
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI, { size: 'medium' })
Vue.config.productionTip = false

// 已登录时刷新管理员信息（含菜单权限），避免本地缓存的权限过期导致误拦截
if (store.state.auth.token) {
  store.dispatch('auth/fetchMe').catch(() => {})
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
